import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  readonly hasError: boolean;
}

/** The application error view (bundle class `ks`, main chunk l.15390). */
export class ErrorBoundary extends Component<{ readonly children: ReactNode }, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[MUTATIO618] Component Error:', error, info);
  }

  override render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="error-boundary">
        <div className="error-boundary__content">
          <h2 className="hero__ohm-text" aria-hidden="true">
            <span className="ohm-glyph">Ω</span>
          </h2>
          <h2 className="error-boundary__title">SYSTEM DISRUPTION</h2>
          <p className="error-boundary__text">
            A disturbance in the matrix has been detected. The system is recalibrating.
          </p>
          <button
            className="btn btn--outline btn--md"
            onClick={() => {
              this.setState({ hasError: false });
              window.location.reload();
            }}
          >
            REINITIALIZE
          </button>
        </div>
      </div>
    );
  }
}
